import { Placeholder } from './Placeholder';

export function ComingSoon({ label, phase }: { label: string; phase: string }) {
  return (
    <Placeholder
      kicker="Coming soon"
      title={label}
      body={
        <>
          Planned for <b>{phase}</b> of the D-ORCA roadmap. This placeholder
          exists so the navigation shell reflects the full information
          architecture; the feature itself will land as a separate spec.
        </>
      }
    />
  );
}
